// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleSimpleList_container_iiVVN"};